import React from 'react'
import PropTypes from 'prop-types'
import SubmitButton from 'forms/shared/buttons/submit'
import QuestionaireForm from './form'

const QuestionaireModal = ({ onAccept, onClose, reasons }) => (
  <div className="questionaire-modal">
    <QuestionaireForm form="questionaire-modal-form" onSubmit={onAccept} reasons={reasons} />
    <div className="flex justify-between items-center">
      <button className="flex-1 py-3 mx-3" onClick={onClose}>Cancel</button>
      <SubmitButton
        className="btn-primary flex-1 py-3 mx-3"
        formName={'questionaire-modal-form'}
      >
        Submit
      </SubmitButton>
    </div>
  </div>
)

QuestionaireModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  reasons: PropTypes.array,
}


export default QuestionaireModal
